import swal from 'sweetalert';

export default {
  error: text => swal(
    text,
    {
      icon: 'error',
      buttons: [false, '确定'],
      closeOnClickOutside: false,
    },
  ),

  succ: text => swal(
    text,
    {
      icon: 'success',
      buttons: [false, '确定'],
    }
  ),

  swal: options => swal(options),

  noAccess() {
    this.error('您无此操作权限，请咨询小猴编程老师！');
  },

  swalAgent(
    err,
    defaultText,
    options,
  ) {
    if (
      typeof err === 'object'
      && err.status === 401
    ) return undefined;
    const { data = {} } = err;
    return swal(
      data.message || defaultText,
      { icon: 'error', buttons: [false, '确定'], ...options },
    );
  },

  offlinePrompt() {
    return this.error('您的账号已在其他设备登录，如非本人操作，请重新登录！');
  },
};
